import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/7d243b86/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import { StructuredListWrapper, StructuredListHead, StructuredListRow, StructuredListCell, StructuredListBody, UnorderedList, ListItem } from 'carbon-components-react';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Caption = makeShortcode("Caption");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <AnchorLinks mdxType="AnchorLinks">
      <AnchorLink mdxType="AnchorLink"> Anatomy </AnchorLink>
      <AnchorLink mdxType="AnchorLink"> Requesting information </AnchorLink>
      <AnchorLink mdxType="AnchorLink"> Best practices </AnchorLink>
    </AnchorLinks>
    <h2 {...{
      "id": "anatomy"
    }}>{`Anatomy`}</h2>
    <p>{`The following diagram outlines the primary components within the chatbot pattern.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "44.64285714285714%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAAAsSAAALEgHS3X78AAABeElEQVQoz4WS70vCQBzG+9d9GZFQ9L4XvZBEmJlCiFhmFIZkEVOnOXPpLLb5I/O2u/14ut10CKEdHMfdw/O5577f28NqBEEg1vGXifLtI2q1B1Srd2g1mwhcT2jd/gilchWVyg2KxSJUVY29a//eGuj70cFQN3B6lkEyeYBEIoFCPg94kfYs95CR8igULiFJEjqdznbg5mG3oyCbzQqT0m7Huu+5sMlS7HVdF3MnMByEEGjaB2azGRilcG0KNo8ghmFiOBxBH4/R67/DNIz/gbZto81TNRoNKIqCqTWBR6jQnmQVF1fXqL/IOEpJGPTfVuXyY+gfIGMMEw4plUo4T6chy824hupAw3Eqh8RJDsn9Qxif6ydzILYlJLZINtA0WKbJO0xizXEc/NgOltQPHTwahb/6ATsTWpYlim/NCe7bNgLmRkDK8L3gF3gOxlOGetfh6RlC61ZguDLXFR0lNMCr5vMgLBTgeR4obxSPBWvho6UHG+kizi9KsKhVLMQg4gAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "chatbot 4",
        "title": "chatbot 4",
        "src": "/static/c7eaec3e5cc4f8cc88dd98cccc3caa52/fb070/chatbot-4.png",
        "srcSet": ["/static/c7eaec3e5cc4f8cc88dd98cccc3caa52/d6747/chatbot-4.png 288w", "/static/c7eaec3e5cc4f8cc88dd98cccc3caa52/09548/chatbot-4.png 576w", "/static/c7eaec3e5cc4f8cc88dd98cccc3caa52/fb070/chatbot-4.png 1152w", "/static/c7eaec3e5cc4f8cc88dd98cccc3caa52/fb104/chatbot-4.png 1728w", "/static/c7eaec3e5cc4f8cc88dd98cccc3caa52/8fefe/chatbot-4.png 2240w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <StructuredListWrapper mdxType="StructuredListWrapper">
  <StructuredListHead mdxType="StructuredListHead">
    <StructuredListRow head mdxType="StructuredListRow">
      <StructuredListCell head mdxType="StructuredListCell">Component</StructuredListCell>
      <StructuredListCell head mdxType="StructuredListCell">Usage</StructuredListCell>
      <StructuredListCell head mdxType="StructuredListCell">Variants</StructuredListCell>
    </StructuredListRow>
  </StructuredListHead>
  <StructuredListBody mdxType="StructuredListBody">
    <StructuredListRow mdxType="StructuredListRow">
      <StructuredListCell mdxType="StructuredListCell">Chatbot header</StructuredListCell>
      <StructuredListCell mdxType="StructuredListCell">
        The chatbot header contains the title of the chat and up to four action
        buttons that control the chatbot application. Typically, the “close”
        icon must always be included.
      </StructuredListCell>
      <StructuredListCell mdxType="StructuredListCell">
        <UnorderedList mdxType="UnorderedList">
          <ListItem mdxType="ListItem">Tight</ListItem>
          <ListItem mdxType="ListItem">Regular</ListItem>
          <ListItem mdxType="ListItem">Regular (with avatar)</ListItem>
          <ListItem mdxType="ListItem">Large</ListItem>
        </UnorderedList>
      </StructuredListCell>
    </StructuredListRow>
    <StructuredListRow mdxType="StructuredListRow">
      <StructuredListCell mdxType="StructuredListCell">System message</StructuredListCell>
      <StructuredListCell mdxType="StructuredListCell">
        System Messages represent the bot's response to the user. Past messages
        will have a faded treatment, whereas active messages have an indicator
        applied (see below)
      </StructuredListCell>
      <StructuredListCell mdxType="StructuredListCell">
        <UnorderedList mdxType="UnorderedList">
          <ListItem mdxType="ListItem">Tight</ListItem>
          <ListItem mdxType="ListItem">Regular</ListItem>
        </UnorderedList>
      </StructuredListCell>
    </StructuredListRow>
    <StructuredListRow mdxType="StructuredListRow">
      <StructuredListCell mdxType="StructuredListCell">User message</StructuredListCell>
      <StructuredListCell mdxType="StructuredListCell">
        A user message indicates what the user has input via text input,
        structured response, or voice.
      </StructuredListCell>
      <StructuredListCell mdxType="StructuredListCell">
        <UnorderedList mdxType="UnorderedList">
          <ListItem mdxType="ListItem">Tight</ListItem>
          <ListItem mdxType="ListItem">Regular</ListItem>
        </UnorderedList>
      </StructuredListCell>
    </StructuredListRow>
    <StructuredListRow mdxType="StructuredListRow">
      <StructuredListCell mdxType="StructuredListCell">Structured response</StructuredListCell>
      <StructuredListCell mdxType="StructuredListCell">
        Structured responses present choices to the user that are easy for the
        bot to understand. When selected, a structured response will change its
        visual appearance and a user message will appear with the same content.
      </StructuredListCell>
      <StructuredListCell mdxType="StructuredListCell">
        <UnorderedList mdxType="UnorderedList">
          <ListItem mdxType="ListItem">Default</ListItem>
        </UnorderedList>
      </StructuredListCell>
    </StructuredListRow>
    <StructuredListRow mdxType="StructuredListRow">
      <StructuredListCell mdxType="StructuredListCell">Chatbot input</StructuredListCell>
      <StructuredListCell mdxType="StructuredListCell">
        The Chatbot input is comprised of a text input field, a configurable
        button for other input (e.g., voice) and a submit button.
      </StructuredListCell>
      <StructuredListCell mdxType="StructuredListCell">
        <UnorderedList mdxType="UnorderedList">
          <ListItem mdxType="ListItem">Tight</ListItem>
          <ListItem mdxType="ListItem">Regular</ListItem>
        </UnorderedList>
      </StructuredListCell>
    </StructuredListRow>
    <StructuredListRow mdxType="StructuredListRow">
      <StructuredListCell mdxType="StructuredListCell">Launch button (not shown)</StructuredListCell>
      <StructuredListCell mdxType="StructuredListCell">
        Launch buttons are the means by which a user initiates a conversation
        with your bot and are the first interaction of the bot experience.
      </StructuredListCell>
      <StructuredListCell mdxType="StructuredListCell">
        <UnorderedList mdxType="UnorderedList">
          <ListItem mdxType="ListItem">Primary</ListItem>
          <ListItem mdxType="ListItem">Alternate</ListItem>
        </UnorderedList>
      </StructuredListCell>
    </StructuredListRow>
    <StructuredListRow mdxType="StructuredListRow">
      <StructuredListCell mdxType="StructuredListCell">Chatbot cards</StructuredListCell>
      <StructuredListCell mdxType="StructuredListCell">
        Cards are used to display more information (including text and images)
        about a significant action that a user can take. They can also be used
        to display text and image together for a purely informational purpose.
      </StructuredListCell>
      <StructuredListCell mdxType="StructuredListCell">
        <UnorderedList mdxType="UnorderedList">
          <ListItem mdxType="ListItem">Card with text (Hero)</ListItem>
          <ListItem mdxType="ListItem">Card with text (Large)</ListItem>
          <ListItem mdxType="ListItem">Card with text (Mini)</ListItem>
          <ListItem mdxType="ListItem">Card with image (Avatar)</ListItem>
          <ListItem mdxType="ListItem">Card with image (Large)</ListItem>
          <ListItem mdxType="ListItem">Card with image (Mini)</ListItem>
          <ListItem mdxType="ListItem">Card with data (Table)</ListItem>
          <ListItem mdxType="ListItem">Card with data (Visualization)</ListItem>
        </UnorderedList>
      </StructuredListCell>
    </StructuredListRow>
  </StructuredListBody>
    </StructuredListWrapper>
    <h2 {...{
      "id": "requesting-information"
    }}>{`Requesting information`}</h2>
    <p>{`The following flow shows a typical exchange between a user and a bot. This model can be used as a baseline to start building useful conversational experiences.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "53.57142857142857%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAABNElEQVQoz5WSzWqEMBSF7Vi6GbqcWRX6AqXVTV9hWuhrdCdd+0I+gc/hxrXbgtQikvifxNuTGEsZCqMXLkdJ7sc5SRznrIjoyuo9+g39onuaplf0Cd+3y17f952LNY6Dq1WK8QPDVNc1SSnJlkiS5ITlfRiGN6ugRcndWeuANQMxXoum6ZQFdnmeP+v1KIrcVUDeTWYj66ZAE0ZFQigyQKVUD3lcjsbzvMuRiWYgBgyQcybRahgGwhn2iO/NRzPuVjlU6hzIAeSq73vjENAnvQ7dOWsKG3+BQggqy1JWVaUYY8gudORtQERx7UCgXeGWR4Ak/s2lbHa4ABHPPJu2bf8+GwWQZxNsAwLyjpgDHOaAfAHwDf2EPmxyWBSFUcD2aZrexXF8yLLsCNARrg8AXVvgv/M/Z7ZSMv/fwKkAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Requesting information from a chatbot",
        "title": "Requesting information from a chatbot",
        "src": "/static/3971374d16e1697d4d71cb890a6613c2/fb070/chatbot-1.png",
        "srcSet": ["/static/3971374d16e1697d4d71cb890a6613c2/d6747/chatbot-1.png 288w", "/static/3971374d16e1697d4d71cb890a6613c2/09548/chatbot-1.png 576w", "/static/3971374d16e1697d4d71cb890a6613c2/fb070/chatbot-1.png 1152w", "/static/3971374d16e1697d4d71cb890a6613c2/fb104/chatbot-1.png 1728w", "/static/3971374d16e1697d4d71cb890a6613c2/8fefe/chatbot-1.png 2240w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <h2 {...{
      "id": "best-practices"
    }}>{`Best practices`}</h2>
    <p>{`At a minimum, use these best practices to help ensure a successful conversational experience. For more in-depth conversational principles, see `}<a parentName="p" {...{
        "href": "https://www.ibm.com/design/ai/conversation"
      }}>{`IBM Design for Conversational AI`}</a>{`.`}</p>
    <h4 {...{
      "id": "introduction"
    }}>{`Introduction`}</h4>
    <p>{`Ensure your users know they are talking to a bot and that the bot has stated its purpose. Set the context for what questions users can ask about.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "53.57142857142857%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAABRElEQVQoz62STU7DMBCFE7e7XgOxBrWqaA7BJbgCh0gbRarURRfsuQRQrgEVVTZRsmjj/Ms4sT0dh2QFC4N40tOMZzSfLI8t6weNRqMhnaCuCSFXmGtP0Re6MR6PLWP5vk90XK1Wi81mo/Dcuq7L1+s1eJ73rHvb7dZeLpdmwKZpOiDn3FFKgRBCWwIKa6+6h6nNGDMDZlnWAdM0XZRlCXmeK3SLAqztdE9KaSdJYgbEYdKDnbquoSgKhRYIAazthhtSSn8LzP8HiMOkBzv4ToBQhRb6Pf8ETE60A1KaLY7HE0RRJMMwbDU8zYqXAXhMDIFxHH8BE+oEQQCHwwe87/eyrkqAJu+23AppS2a4lKqqSB9vcMuyLKtGCc5oDXD/yJ6GG9491GZA/B5DnOD/m7FPPgMQ07cY5tatuOyBljVvvs2eAZtGIEb+suBvAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Chatbot greeting",
        "title": "Chatbot greeting",
        "src": "/static/5c474060098e0133f1e2d28a2eff51da/fb070/chatbot-7.png",
        "srcSet": ["/static/5c474060098e0133f1e2d28a2eff51da/d6747/chatbot-7.png 288w", "/static/5c474060098e0133f1e2d28a2eff51da/09548/chatbot-7.png 576w", "/static/5c474060098e0133f1e2d28a2eff51da/fb070/chatbot-7.png 1152w", "/static/5c474060098e0133f1e2d28a2eff51da/fb104/chatbot-7.png 1728w", "/static/5c474060098e0133f1e2d28a2eff51da/8fefe/chatbot-7.png 2240w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <Caption mdxType="Caption">chatbot greeting</Caption>
    <h4 {...{
      "id": "user-intent"
    }}>{`User intent`}</h4>
    <p>{`Typically, a user inputs an intent, which can be request for information or a task for the bot to complete. This can take the form of a text (shown here) as well as a structured response (see next section)`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "53.57142857142857%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAABa0lEQVQoz5WSsU7DMBCGY7cbvAUSM6iIrZF4DCQW3oR2qKpGlSIVdWJl4QFAlBFmxEDpUjogkUjFdpMqIU0d5zib0AUGc9IvX3y+z5dfdpw/olar/aRbGPuU0j3MtRqoHV2o1+uOdfT7farXXq/XHAwGgN+y2+3mvu+D53k3ujYcDgnu2QHX6zWtVhcwiqLQUjrP83yka5iSLMvsgFEUGeBisXCTJIE4jhVKYgDu3eoaXkAYY3ZAbKbf4NhN009YLpclSiqlAC8zE2JOhBB2QGymFdhdrTLAKUuULMtyA9QTWgM5EwYoROQyxiEMwzIIAome6mk3HloDEWCAnAt3Op3CZDJR4/FYcs6Bi8h4yIUgH0z8z0NZSJyQQafTgVarrdrtM7i6vBhVx8jz44MdME1TA8Rn0cRfVLPZLA/f37KX1zmcngfXunZ3/0SO/bkdEJ+HWfHNbaP5B+hXQ4srOHROYLfy0HGO4FfvF3+UFfSi34sWAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "User Intent",
        "title": "User Intent",
        "src": "/static/a0404cd6a268d99351e7b902d4653f98/fb070/chatbot-8.png",
        "srcSet": ["/static/a0404cd6a268d99351e7b902d4653f98/d6747/chatbot-8.png 288w", "/static/a0404cd6a268d99351e7b902d4653f98/09548/chatbot-8.png 576w", "/static/a0404cd6a268d99351e7b902d4653f98/fb070/chatbot-8.png 1152w", "/static/a0404cd6a268d99351e7b902d4653f98/fb104/chatbot-8.png 1728w", "/static/a0404cd6a268d99351e7b902d4653f98/8fefe/chatbot-8.png 2240w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <Caption mdxType="Caption">User intent</Caption>
    <h4 {...{
      "id": "structured-responses"
    }}>{`Structured responses`}</h4>
    <p>{`Prompt for additional details with a menu of structured responses. This narrows the scope to more specific information to answer the user’s question.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "53.57142857142857%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAABdElEQVQoz42RzU7CQBDH28KN1zCeNRAifQefwmeQC9wJEBLChYMJVx9CxVfgRLAlwKEl/aaWam33Y5zW1osedpLN/Hen/e3s/CXpn6jVapVsYFwrinKFOl9NXBd5oV6vS8IxmUyUPI9Go85sNuO4J4PBIJ1OpzAej5/z2nw+l4fDoRgwyzKlzCpgMMaAc85ynabpa15DKSdJIgZ0XbcA+r7fsW0bjscjN02TIAyiKFpWQKyLARFSAIMgUA3DgO12y3VdpwgAz/MKIJ7JqMWA2IVSdqE6jgO9Xo/3+33a7XZhsVgsy8/k1WolBnTsnyefglA1DRM2mw3HjiheBI7rFkDLsmS8TAyI8/qdoabpoGka2+/3BE2C9yh+qWbo+ScxIJqglOaoh8MB1us17HY7RkgKPA0LlwllMksETTmfzwUwjuMbfCYLwzDLvj4TPwa4f0yeqg7vHj7EgISQKjcopa2M0BYCmm8WtKVbelkCJamd/fn3GzxSE8f7Bp/0AAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Structured Responses",
        "title": "Structured Responses",
        "src": "/static/3c47070d5f342483f8f87b3b8f9f6ea2/fb070/chatbot-9.png",
        "srcSet": ["/static/3c47070d5f342483f8f87b3b8f9f6ea2/d6747/chatbot-9.png 288w", "/static/3c47070d5f342483f8f87b3b8f9f6ea2/09548/chatbot-9.png 576w", "/static/3c47070d5f342483f8f87b3b8f9f6ea2/fb070/chatbot-9.png 1152w", "/static/3c47070d5f342483f8f87b3b8f9f6ea2/fb104/chatbot-9.png 1728w", "/static/3c47070d5f342483f8f87b3b8f9f6ea2/8fefe/chatbot-9.png 2240w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <Caption mdxType="Caption">Structured responses</Caption>
    <h4 {...{
      "id": "reflection"
    }}>{`Reflection`}</h4>
    <p>{`The bot should reflect its understanding of the query in the response (when appropriate) to ensure understanding, or before performing a significant action. Note: This process of slotfilling may need to be repeated until the bot has all the information required to answer the user’s initial question.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "53.57142857142857%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAABeklEQVQoz42ST2rCUBDGkwhuvEbpukWRmjv0FL1CDyGigi5cWFcuegQ3aRXBE4iWCCIq+aumShOryXsv03mpKZR28QaGGfje/PhmEkn6JzKZTNrmMG4VRbnBnmce84oL2WxWEo5arabwWqlUSs1mM67X66RcLoeNRgOq1eoL19rttoy6GDCKogQIAGoQBIDD0Ol0GK+9Xm9weSYvFgsx4Ha7TYCHw6Fk2zaMx+N4MpkQwzBgtVr1uTYcDmXTNMWAjuMkQM/z1PV6DZgxDlPGGKDj/sW9vN/vxYDoKgHudjt1uVzCbDaL0RklhPwC4gZiQHyYAF13o4ZhCKPRKG61WrTb7YKmaf30hvP5XAy4cb9v+O7tS4ZhcofsbTol6Bgs233lmq7rsu1sxICWZf2sjKsC/zCe984AYgDyMUhXjs+CN8Q7JUDf9++wZ74fRIyEJ+8I8Pj8qaXAh6ejGBCPn1RKaQ7/ycLpdC4A0LxuQ1G6p9cXoCQVoz+zX9bFDcucELD0AAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Reflection",
        "title": "Reflection",
        "src": "/static/7affed15dffa58816e6990f70595c43f/fb070/chatbot-10.png",
        "srcSet": ["/static/7affed15dffa58816e6990f70595c43f/d6747/chatbot-10.png 288w", "/static/7affed15dffa58816e6990f70595c43f/09548/chatbot-10.png 576w", "/static/7affed15dffa58816e6990f70595c43f/fb070/chatbot-10.png 1152w", "/static/7affed15dffa58816e6990f70595c43f/fb104/chatbot-10.png 1728w", "/static/7affed15dffa58816e6990f70595c43f/8fefe/chatbot-10.png 2240w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <Caption mdxType="Caption">Reflection</Caption>
    <h4 {...{
      "id": "provide-a-response-and-request-feedback"
    }}>{`Provide a response and request feedback`}</h4>
    <p>{`The bot should provide a thoughtful, informative response to the user’s intent, based on the information they have provided throughout the conversation. When appropriate, be sure to provide an opportunity for users to give feedback. Consider allowing the user to input a custom response. Provide an opportunity for users to give feedback where possible. Consider allowing the user to input a custom response.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "53.57142857142857%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAAA8UlEQVQoz6WSTW6DMBCFc3rEhg2rHIFL9AQI2IQNf2EBGIESkmCqxAa/4qmIWimqFHckaxbz9Om98ezwopRS1MdxRBRFCMMQQRDA930kSfLUbLqftXsFXJaFelVVcF0XjuPAtm1YlgXP894HbkIN7vsewzCQWyHEr/nbQA3ouo6A0zShaRrkeW7uUEq5Anu0LSOnRVEgjmNzoBByhRyRZRk501Dt2jiydrjByrIEYwyc8/9FTtOUoDouYy1GPj1hRp9S1zVFPZ3OuF4GKMGhx0bAeZ7pXG7rW+Qd7Cyw/3hohdkONxffh67w+VA4VOpP4BeNBFeK/DGL1QAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Provide a response and request feedback",
        "title": "Provide a response and request feedback",
        "src": "/static/dde5048201cc9472d1c1ae3bc456dedd/fb070/chatbot-11.png",
        "srcSet": ["/static/dde5048201cc9472d1c1ae3bc456dedd/d6747/chatbot-11.png 288w", "/static/dde5048201cc9472d1c1ae3bc456dedd/09548/chatbot-11.png 576w", "/static/dde5048201cc9472d1c1ae3bc456dedd/fb070/chatbot-11.png 1152w", "/static/dde5048201cc9472d1c1ae3bc456dedd/fb104/chatbot-11.png 1728w", "/static/dde5048201cc9472d1c1ae3bc456dedd/8fefe/chatbot-11.png 2240w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <Caption mdxType="Caption">Provide a response and request feedback</Caption>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      